import { render, staticRenderFns } from "./IpadUserList.vue?vue&type=template&id=61dd39ea&scoped=true&"
import script from "./IpadUserList.vue?vue&type=script&lang=js&"
export * from "./IpadUserList.vue?vue&type=script&lang=js&"
import style0 from "./IpadUserList.vue?vue&type=style&index=0&id=61dd39ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd39ea",
  null
  
)

export default component.exports